/*
  Project: brockmeyer
  Author: tobias lorenz
 */

import $ from 'jquery';

// $('.scrollink').on('click', function (event) {
  
//   $('html, body')
//     .delay(300)
//     .animate({
//       scrollTop: $($.attr(this, 'href')).offset().top
//     }, 800);

//   return false;
// });

// $(function(){ 
//   $("a[href^='#']").on('click', function(e) { 
//       e.preventDefault(); 

//       $('html, body')
//       .delay(300)
//       .animate({
//       scrollTop: $($.attr(this, "href")).offset().top
//       }, 800);
//     }) 
// }) 


$( document ).ready(function() {
  $(document).on('click', "a[href^='#']", function(e) {
    e.preventDefault(); 

    $('html, body')
    .delay(300)
    .animate({
    scrollTop: $($.attr(this, "href")).offset().top
    }, 800);
  });
});



import greet from './modules/greeting';
import brockmeyer from './additional/brockmeyer';
import swiper from './additional/swiper';
import navigation from './additional/navigation';
import news_swiper from './additional/news-slider';
import client_swiper from './additional/client-slider';
import googleMap from './additional/googleMap';
import popup from './additional/popup';
import header from './additional/header';
import hideheader from './additional/hideheader';
import kontaktswiper from './additional/kontakt-swiper';
import leistungswiper from './additional/leistung-swiper';
import waypoint from './additional/waypoints';
import waypointFull from './additional/waypoints-full';

greet('World');
brockmeyer();

// now whenever you are ready do whatever you want
// (in this case I use jQuery to scroll to the tag after the page has loaded)


// $( window ).load(function() {
//   swiper();
// });






// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/app.js